export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f87b3408f17204c0ddb37e8a778b5e5c50c72ab82&name=fetchTypeahead!'